export default {
  namespaced: true,
  state: {
    goToFinder: false,
    isFiltersCollapsibleOpen: false,
    params: {},
    criteria: undefined,
    filters: {
      registrationTypes: undefined,
      memberTypes: undefined,
      memberId: undefined,
      tags: [],
      entityType: undefined,
      location: undefined,
      eventDateRange: [undefined, undefined],
      organisation: {
        _id: undefined,
        level: undefined,
      },
      productId: undefined,
      regoOpen: 'open',
      gender: undefined,
      ageFrom: 1,
      ageTo: 99
    },
    personalise: {
      regoType: undefined,
      memberType: undefined,
      memberId: undefined,
      location: undefined,
      eventDateRange: [undefined, undefined],
      tags: [],
      organisationId: undefined,
      regoOpen: 'open',
    },
  },
  mutations: {
    setFiltersCollapsibleOpen(state, isOpen) {
      state.isFiltersCollapsibleOpen = isOpen;
    },
    setGoToFinder(state, goToFinder) {
      state.goToFinder = goToFinder;
    },
    setParams(state, params) {
      state.params = params;
    },
    setFilters: (state, payload) => {
      const { type, memberType } = payload;
      if (type === 'event') {
        state.filters.memberTypes = memberType;
        state.filters.registrationTypes = 'indv';
        state.filters.entityType = 'event';
      } else if (type === 'participate') {
        state.filters.memberTypes = memberType;
        // push indv and indv-to-team
        // state.filters.registrationTypes.push('indv');
        state.filters.registrationTypes = 'indv-to-team';
        state.filters.entityType = undefined;
      } else if (type === 'team') {
        state.filters.registrationTypes = 'team';
        state.filters.entityType = 'team';
      } else if (type === 'membership') {
        state.filters.entityType = 'membership';
        state.filters.memberTypes = memberType;
      }
      state.personalise.regoType = type;
      if (memberType) {
      // eslint-disable-next-line prefer-destructuring
        state.personalise.memberType = memberType;
      }
    },
    setPersonalise: (state, payload) => {
      state.personalise = payload;
    },
    clearFitlers(state) {
      state.criteria = undefined;
      state.filters = {
        registrationTypes: undefined,
        memberTypes: undefined,
        memberId: undefined,
        tags: [],
        entityType: undefined,
        location: undefined,
        eventDateRange: [undefined, undefined],
        organisation: {
          _id: undefined,
          level: undefined,
        },
        productId: undefined,
        regoOpen: 'open',
        gender: undefined,
        ageFrom: 1,
        ageTo: 99
      };
      state.personalise = {
        regoType: undefined,
        memberType: undefined,
        memberId: undefined,
        location: undefined,
        eventDateRange: [undefined, undefined],
        tags: [],
        organisationId: undefined,
        regoOpen: 'open',
      };
    },
    setCriteria: (state, criteria) => {
      state.criteria = criteria;
    },

    clear(state) {
      state.goToFinder = false;
      state.params = {};
    },
  },
  actions: {
  },
  getters: {
    goToFinder(state) {
      return state.goToFinder;
    },
    params(state) {
      return state.params;
    },
    getFilters(state) {
      return state.filters;
    },
    getPersonalise(state) {
      return state.personalise;
    },
    getCriteria(state) {
      return state.criteria;
    },
    isFiltersCollapsibleOpen(state) {
      return state.isFiltersCollapsibleOpen;
    },
  },
};
